<script lang="ts">
    import type { ScenarioFiles } from 'Generated/RestClient.g';
    import ColumnOptions from 'Pages/PublicationPage/Views/ColumnOptions';
    import FileDetailsEntry from './FileDetailsEntry.svelte';

    export let options: ColumnOptions;
    export let item: any;
    export let key: string;
    export let config: { extraComponent?: any };

    $: summaryFormatted = options.formatter?.(item[key]) ?? item[key];
    $: files = item.files as ScenarioFiles;
    $: presentationId = item.id as string;
</script>

<details>
    <summary>
        {summaryFormatted}
    </summary>
    <div>
        {#each files.presentationFiles as presentationFile}
            <FileDetailsEntry scenarioId={presentationId} fileName={presentationFile.name} replaceable={false} restoreable={false} />
        {/each}

        {#each files.dataFiles as dataFile}
            <FileDetailsEntry scenarioId={presentationId} fileName={dataFile.name} replaceable={dataFile.name.endsWith(".csv")} restoreable={dataFile.canBeRestoredToOriginalState} />
        {/each}
    </div>
    {#if config.extraComponent !== undefined}
        <svelte:component this={config.extraComponent} item={item} />
    {/if}
</details>

<style>
    details {
        font-weight: normal;
        cursor: initial;
    }

    details div {
        margin-top: .4rem;
        margin-left: .8rem;
        line-height: 1.4rem;
    }

    summary {
        cursor: pointer;
        font-weight: 600;
        text-overflow: ellipsis;
        overflow: hidden;
        line-height: 1.3rem;
        white-space: nowrap;
    }
</style>
